import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 2px;
  margin-bottom: 5px;
  position: relative;
`;
